<template>
    <div class="transactions-details">
        <h2 class="font-weight-bold mb-4">Transactions</h2>
        <div class="d-flex align-items-center mb-4">
            <router-link :to="'/vendor-transactions/'">
                <p class="mb-0 font-weight-bold">Transactions</p>
            </router-link>
            <i class="fas fa-chevron-right mx-3"></i>
            <p class="mb-0">Transactions Details</p>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6 bg-gray rounded shadow px-5 py-3">
                <div class="row">
                    <div class="col-6">
                        <p>Status</p>
                        <status-button :status="transaction_details.status ? transaction_details.status : null" />
                    </div>
                    <div class="col-6">
                        <p>Amount</p>
                        <p class="font-weight-bold">GHS {{transaction_details.total_amount_paid}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 bg-gray rounded p-3 shadow">
              <div class="row">
                  <div class="col-4">
                      <p class="mb-2">Date</p>
                      <p class="font-weight-bold">{{ new Date(transaction_details.created_at) | dateFormat('DD/MM/YYYY h:mm A') }}</p>
                  </div>
                  <div class="col-4" v-if="transaction_details.service_type">
                      <p class="mb-2">Type</p>
                      <p class="font-weight-bold">{{transaction_details.service_type.name}}</p>
                  </div>
                  <div class="col-4">
                      <p class="mb-2">JetPayID</p>
                      <p class="font-weight-bold">{{transaction_details.short_id}}</p>
                  </div>
              </div>
              <div class="row mt-5">
                  <div class="col-4">
                      <p class="mb-2">Service Reference</p>
                      <p class="font-weight-bold">{{transaction_details.service_reference}}</p>
                  </div>
                  <div class="col-4">
                      <p class="mb-2">Bill Of Lading</p>
                      <p class="font-weight-bold">{{transaction_details.bill_of_lading || 'N/A'}}</p>
                  </div>
                  <!-- <div class="col-4">
                    <p class="mb-2">Phone</p>
                    <p class="font-weight-bold" v-if="transaction_details.phone_number">{{transaction_details.phone_number}}</p>
                    <p class="font-weight-bold" v-else>No Phone Available</p>
                  </div>
                  <div class="col-4">
                      <p class="mb-2">Payer</p>
                      <p class="font-weight-bold">{{transaction_details.payer_account.name}}</p>
                  </div> -->
              </div>
          </div>
        </div>
        <div class="row mt-5">
          <!-- payer card -->
          <div class="row mb-5" v-if="transaction_details.payer_account">
            <div class="col-12 col-lg-10">
              <div class="rounded bg-light shadow">
                <div class="p-3">
                  <div class="row">
                    <div class="col-6 text-left mb-4">
                      <span class="text-hard-bold">Payer</span>
                      <p class="mb-0 mt-3" v-if="transaction_details.payer_account.name">{{transaction_details.payer_account.name}}</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Email</span>
                      <p class="mb-0 mt-3 text-break" v-if="transaction_details.payer_account.email">{{transaction_details.payer_account.email}}</p>
                      <p class="mb-0 mt-3" v-else>no email available</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Location</span>
                      <p class="mb-0 mt-3 text-break" v-if="transaction_details.payer_account.mail_address">{{transaction_details.payer_account.address}}</p>
                      <p class="mb-0 mt-3" v-else>no location available</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Phone</span>
                      <p class="mb-0 mt-3" v-if="transaction_details.payer_account.phone_number">{{transaction_details.payer_account.phone_number}}</p>
                      <p class="mb-0 mt-3" v-else>no phone number available</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /payer card -->
          <!-- vendor card -->
          <div class="row mb-5" v-if="transaction_details.vendor_account">
            <div class="col-12 col-lg-10">
              <div class="rounded bg-light shadow">
                <div class="p-3">
                  <div class="row">
                    <div class="col-6 text-left mb-4">
                      <span class="text-hard-bold">Vendor</span>
                      <p class="mb-0 mt-3" v-if="transaction_details.vendor_account.name">{{transaction_details.vendor_account.name}}</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Email</span>
                      <p class="mb-0 mt-3 text-break" v-if="transaction_details.vendor_account.email">{{transaction_details.vendor_account.email}}</p>
                      <p class="mb-0 mt-3" v-else>no email available</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Location</span>
                      <p class="mb-0 mt-3 text-break" v-if="transaction_details.vendor_account.mail_address">{{transaction_details.vendor_account.address}}</p>
                      <p class="mb-0 mt-3" v-else>no location available</p>
                    </div>
                    <div class="col-6 text-left">
                      <span class="text-hard-bold">Phone</span>
                      <p class="mb-0 mt-3" v-if="transaction_details.vendor_account.phone_number">{{transaction_details.vendor_account.phone_number}}</p>
                      <p class="mb-0 mt-3" v-else>no phone number available</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /vendor card -->
        </div>
        <FooterSpacing/>
    </div>
</template>
<script>
//import TransactionAPI from '../api/transactions_api';
import store from '../store';
import StatusButton from '../components/StatusButton.vue';
import FooterSpacing from '../components/FooterMobile.vue';

export default {
  components: {
    StatusButton,
    FooterSpacing
  },
  data() {
      return {
      }
  },
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
  },
  mounted() {
    this.tokenizer();
  },
  computed: {
    customer_account: {
      get: function () {
        return store.state.customer_account;
      },
      set: function (newValue) {
        store.state.customer_account = newValue;
      }
    },
    transaction_details: {
      get: function () {
        return store.state.transaction_details;
      },
      set: function (newValue) {
        store.state.transaction_details = newValue;
      }
    }
  },
  methods: {
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
      }
    }
  }
}
</script>
<style scoped>
.bg-gray {
    background: #f1f1f1;
}
.rounded-pills {
    border-radius: 30px;
}
</style>